import translation from './translation.json';

export const fr = {
    ...translation,

    // Overrides
    "register.register": "S'inscrire",
    "academics.transcript": "Relevé de notes",
    "main.menu.grading": "Relevé de notes",
    "finance.table header.balance": "Solde"
};